import React from 'react'
import { Outlet, useLocation, NavLink, useNavigate, useParams } from 'react-router-dom'
import { Tabs, Tab, AppBar, } from '@mui/material';
import { Button } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import useInventory from '../../Inventory/hook/useInventory';
// import { Spinner } from '../../components/Spinner/Spinner';
// import useProjectAddUpdate from './Hooks/useProjectAddUpdate';
// import Modal from '../../components/Modal'

const InventoryDetails = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const {data,methods} = useInventory()
    const {inventoryDetailList} = data
    const {InventoryD_Id} = useParams()

    const allTabs = [
        {
            label: "Purchase Order",
            value: `/inventory/${InventoryD_Id}/purchase-order`,
        },
        {
            label: "Assign/Use History",
            value: `/inventory/${InventoryD_Id}/assign-inventory`,
        },
    ];

    return (
        <>
            {/* {isLoading && <Spinner />} */}
            <ToastContainer />
            <div className="contact">
                <div className="container bg">
                    <div className="row">
                        <div className="col-lg-12 pt-4">
                            <div className="col-lg-12 pt-4 mt-2 ms-4">
                                <div className="row my-3">
                                        <p className="col-lg-6"><span className="fw-bold">Product Name :</span> <span className="text-muted">{inventoryDetailList?.productName}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Category:</span> <span className="text-muted">{inventoryDetailList?.category?.name}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Vendor:</span> <span className="text-muted">{inventoryDetailList?.vendor?.name}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Stock Quantity:</span> <span className="text-muted">{inventoryDetailList?.quantity}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">MRP:</span> <span className="text-muted">{inventoryDetailList?.price}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Purchase Price:</span> <span className="text-muted">{inventoryDetailList?.purchasePrice}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Re-order:</span> <span className="text-muted">{inventoryDetailList?.minimumQuantityLevel}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Quantity Used:</span> <span className="text-muted">{inventoryDetailList?.quantityUsed}</span></p>
                                        <p className="col-lg-6"><span className="fw-bold">Available Quantity:</span> <span className="text-muted">   {inventoryDetailList?.quantity - inventoryDetailList?.quantityUsed}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ticket's and note's tabs */}
                <div className="container bg my-4">
                    <div className="border" style={{ backgroundColor: "white" }}>
                        <AppBar position="static" sx={{ background: "#fff" }}>
                            <Tabs value={location.pathname}>
                                {allTabs.map((item, i) =>
                                    <Tab key={i}
                                        label={item.label}
                                        value={item.value}
                                        component={NavLink}
                                        to={item.value}
                                    />
                                )}
                            </Tabs>
                        </AppBar>
                        <Outlet
                          context={{ data, methods }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default InventoryDetails